import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from '../self';

const pixelsLoadingSelector = createSelector(selfSelector, (pixels) => pixels.isLoading);

export default pixelsLoadingSelector;
